import React, { useState } from 'react'
import { useToasts } from 'react-toast-notifications'
import { useDispatch } from 'react-redux'
import { clearMyOrder, clearDataPurchaseDetail } from '_redux/modules/order'
import { callNewListOrder } from '_redux/modules/event'
import eventApi from '_api/event'
import {
  ORDER_DISCOUNT_CONDITION_MIN_SPEND,
  ORDER_DISCOUNT_TYPE_FIXED,
  PAYABLE,
  EVENT_CLOSE,
  NOT_PAYABLE,
  PAYNOW,
} from '_utils/constant'
import ModalRequestPayment from '../../components/ModalRequestPayment'

export default function DiscountInfor({
  orderDiscountEnabled,
  isDiscountEnabled,
  orderDiscount,
  payable,
  status,
  id,
  setTimeRender,
  eventAndOrderById,
  paynow,
  showRequestButton = true,
}) {
  const [modalRequest, setModalRequest] = useState(false)
  const toggleRequest = () => setModalRequest(!modalRequest)
  const { addToast } = useToasts()
  const dispatch = useDispatch()

  const onControlPaymentClicked = async () => {
    if (status === EVENT_CLOSE) {
      if (payable === NOT_PAYABLE) {
        toggleRequest()
      } else {
        try {
          dispatch(clearDataPurchaseDetail())
          dispatch(clearMyOrder())
          await eventApi.updateEventRequestPayment(id, {
            payable: payable === 1 ? 0 : 1,
          })
          dispatch(callNewListOrder())
          setTimeRender((prevState) => prevState + 1)
        } catch (error) {
          const { msgResp } = error
          addToast(msgResp, { appearance: 'error', autoDismiss: true })
        }
      }
    } else {
      alert('Request payment when event is closed')
    }
  }

  const isEnabled = orderDiscountEnabled || isDiscountEnabled
  if (!isEnabled || !orderDiscount) return null

  const hasThreshold = Number(orderDiscount?.threshold) > 0
  const conditionText = hasThreshold
    ? (orderDiscount.condition === ORDER_DISCOUNT_CONDITION_MIN_SPEND
      ? `Spend $${Number(orderDiscount.threshold).toFixed(2)}+`
      : `Order ${orderDiscount.threshold} + items`)
    : ''
  const discountText = orderDiscount.type === ORDER_DISCOUNT_TYPE_FIXED
    ? `$${Number(orderDiscount.amount).toFixed(2)} off`
    : `${orderDiscount.amount}% off`

  return (
    <div className='tier-list-container' style={{ marginBottom: '15px' }}>
      <div className='tier-item-manage-order'>
        <div className='tier-info'>
          <span className='tier-tag'>🏷</span>
          <div className='tier-info-content' style={{ display: 'flex', flexDirection: 'column' }}>
            {conditionText ? (
              <span className='tier-text'>
                {conditionText}
              </span>
            ) : null}
            <span className='tier-text'>
              Discount {discountText}
            </span>
          </div>
        </div>
        {/* request payment */}
        {showRequestButton && paynow !== PAYNOW && (
          <button
            className={`request-btn ${payable === PAYABLE ? 'requested' : ''}`}
            style={{ marginTop: 0, fontSize: '12px' }}
            onClick={onControlPaymentClicked}
          >
            <input type='checkbox' checked={payable === PAYABLE} readOnly className='checkbox' />
            <span>{payable === PAYABLE ? 'Payment Requested' : 'Request Payment'}</span>
          </button>
        )}
      </div>
      {showRequestButton && eventAndOrderById && (
        <ModalRequestPayment
          modalRequest={modalRequest}
          toggleRequest={toggleRequest}
          eventAndOrderById={eventAndOrderById}
          setTimeRender={setTimeRender}
        />
      )}
    </div>
  )
}
